<template>
  <div class="add-parametro">
    <h1>Agregar Nuevo Parámetro</h1>
    
    <div class="card p-4 bg-light">
      <form @submit.prevent="submitForm">
        <div class="mb-3">
          <label for="parametroClave" class="form-label">Clave</label>
          <input
            type="text"
            class="form-control"
            id="parametroClave"
            :value="parametro.ParametroClave"
            @input="updateField('ParametroClave', $event.target.value)"
            required
          />
        </div>
        <div class="mb-3">
          <label for="valor" class="form-label">Valor</label>
          <input
            type="text"
            class="form-control"
            id="valor"
            :value="parametro.Valor"
            @input="updateField('Valor', $event.target.value)"
            required
          />
        </div>
        <div class="mb-3">
          <label for="descripcion" class="form-label">Descripción</label>
          <textarea
            class="form-control"
            id="descripcion"
            rows="3"
            :value="parametro.Descripcion"
            @input="updateField('Descripcion', $event.target.value)"
          ></textarea>
        </div>
        <div class="d-flex gap-2">
          <button type="submit" class="btn btn-primary" :disabled="saving">
            {{ saving ? 'Guardando...' : 'Guardar Parámetro' }}
          </button>
          <button type="button" class="btn btn-secondary" @click="goBack" :disabled="saving">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import AddParametroViewController from '../controllers/AddParametroViewCtrl.js';

export default {
  name: 'AddParametroView',
  components: {
  },
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new AddParametroViewController()
    }
  },
  computed: {
    parametro() {
      return this.controller.getParametro();
    },
    saving() {
      return this.controller.isSaving();
    },
    error() {
      return this.controller.getCurrentError();
    }
  },
  created() {
    this.controller.initialize();
  },
  methods: {
    async submitForm() {
      if (!this.controller.validateForm()) {
        this.$alert.error('Por favor, complete todos los campos requeridos.');
        return;
      }

      try {
        const response = await this.controller.saveParametro();
        this.$mgkResponse.handleResponse(response, 'Parámetro guardado con éxito.', 'Error al guardar el parámetro.');
        if (response.data.Number > 0) {
          this.$router.push('/parametros');
        }
      } catch (error) {
        this.$alert.error('Error al guardar el parámetro. Por favor, intente de nuevo.');
      }
    },
    goBack() {
      this.$router.push('/parametros');
    },
    updateField(field, value) {
      this.controller.updateField(field, value);
    }
  }
}
</script>

<style scoped>
.add-parametro {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
